module.exports = __webpack_public_path__ + "AdobeStock_285202108_monitor2.svg?c062e4f733c98cb6752b753136d2c187";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_monitor2.svg
// module id = 325
// module chunks = 0